import {
  NotificationTip,
  NotificationTipText,
} from '../notifications/notification-tip.style';

const StimulusContentWarning = () => {
  return (
    <NotificationTip $marginBottom={24}>
      <NotificationTipText marginBottom={0}>
        We would like to advise that some of our content may contain images,
        voices and names of deceased Aboriginal and Torres Strait Islander
        Peoples.{' '}
      </NotificationTipText>
    </NotificationTip>
  );
};

export default StimulusContentWarning;
